package com.nonopn.skywatcher.design.widgets

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.PagerScope
import androidx.compose.foundation.pager.PagerState
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp
import com.nonopn.skywatcher.design.theme.AppColor

@Composable
fun CustomHorizontalPager(
    modifier: Modifier,
    state: PagerState,
    pageContent: @Composable (PagerScope.(page: Int, paddingBottom: Dp) -> Unit)
) {
    val bottomHeight = 80.dp

    Box(modifier = modifier) {
        HorizontalPager(
            modifier = Modifier.fillMaxSize(),
            state = state
        ) { page -> pageContent(page, bottomHeight) }

        Row(
            modifier = Modifier.align(Alignment.BottomCenter)
                .height(bottomHeight)
                .background(AppColor.GraySemiTransparentLight),
            verticalAlignment = Alignment.CenterVertically
        ) {
            Indicators(
                count = state.pageCount,
                size = 10,
                spacer = 5,
                selectedColor = AppColor.Gray,
                unselectedColor = AppColor.White,
                selectedIndex = state.currentPage,
                selectedLength = 50,
                modifier = Modifier.weight(4f)
            )
        }
    }
}